export default __webpack_public_path__ + "static/media/animated-m.69c49e2e.png";